/** MUI DataGrid mode values (paginationMode, sortingMode, filterMode). */
export const DATA_GRID_MODE = {
  CLIENT: 'client',
  SERVER: 'server',
} as const;

/** MUI DataGrid `rowSelectionModel.type` values. */
export const ROW_SELECTION_TYPE = {
  INCLUDE: 'include',
  EXCLUDE: 'exclude',
} as const;
